// src/components/admin/SubfieldManagerModal.js - WERSJA Z WYŚWIETLANIEM SZABLONÓW

import React, { useState, useEffect } from 'react';
import { RenderMarkdownWithLatex } from '../../utils/utils';

const apiUrl = process.env.REACT_APP_API_SOURCE;
const token = localStorage.getItem("token");

const SubfieldManagerModal = ({ isOpen, onClose, fieldId, onDataChange }) => {
  const [subfields, setSubfields] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [newSubfieldName, setNewSubfieldName] = useState('');
  const [newEloThreshold, setNewEloThreshold] = useState(1200);

  useEffect(() => {
    if (isOpen && fieldId) {
      setLoading(true);
      setError('');
      fetch(`${apiUrl}subfield-translations/?subfield__field=${fieldId}`, {
        headers: { "Content-Type": "application/json", Authorization: `Token ${token}` }
      })
      .then(res => {
        if (!res.ok) throw new Error('Nie udało się pobrać poddziałów.');
        return res.json();
      })
      .then(data => {
        const sortedData = data.sort((a, b) => a.elo_threshold - b.elo_threshold);
        setSubfields(sortedData);
      })
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
    }
  }, [isOpen, fieldId]);

  const handleSaveThreshold = (subfieldId, newThreshold) => {
    fetch(`${apiUrl}subfield-translations/${subfieldId}/`, {
      method: 'PATCH',
      headers: { "Content-Type": "application/json", Authorization: `Token ${token}` },
      body: JSON.stringify({ elo_threshold: newThreshold })
    }).then(res => {
      if (res.ok) {
        alert('Zapisano pomyślnie!');
        onDataChange();
      } else {
        alert('Błąd zapisu progu ELO!');
      }
    });
  };

  const handleDelete = (subfieldTranslationId, subfieldName) => {
    if (!window.confirm(`Czy na pewno chcesz usunąć poddział "${subfieldName}"? Może to spowodować problemy, jeśli są do niego przypisane zadania!`)) return;
    fetch(`${apiUrl}subfield-translations/${subfieldTranslationId}/`, {
      method: 'DELETE',
      headers: { Authorization: `Token ${token}` }
    }).then(res => {
      if (res.status === 204) {
        setSubfields(subfields.filter(sf => sf.subfield_translation_id !== subfieldTranslationId));
        onDataChange();
      } else {
        alert('Nie udało się usunąć poddziału. Sprawdź konsolę, aby zobaczyć szczegóły.');
      }
    });
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    try {
      const subfieldRes = await fetch(`${apiUrl}subfields/`, {
          method: 'POST',
          headers: { "Content-Type": "application/json", Authorization: `Token ${token}` },
          body: JSON.stringify({ field: fieldId })
      });
      if (!subfieldRes.ok) throw new Error('Błąd przy tworzeniu obiektu Subfield.');
      const newSubfieldData = await subfieldRes.json();

      const translationRes = await fetch(`${apiUrl}subfield-translations/`, {
          method: 'POST',
          headers: { "Content-Type": "application/json", Authorization: `Token ${token}` },
          body: JSON.stringify({
              subfield: newSubfieldData.subfield_id,
              subfield_name: newSubfieldName,
              elo_threshold: newEloThreshold,
              lang: 'pl'
          })
      });
      if (!translationRes.ok) throw new Error('Błąd przy tworzeniu obiektu SubfieldTranslation.');

      setNewSubfieldName('');
      setNewEloThreshold(1200);
      onDataChange();
      onClose();
    } catch (error) {
      alert(error.message);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex justify-center items-center p-4">
      <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-3xl max-h-[90vh] flex flex-col">
        <div className="flex justify-between items-center mb-4 border-b pb-2">
          <h2 className="text-2xl font-bold text-gray-800">Zarządzaj Poddziałami</h2>
          <button onClick={onClose} className="text-3xl text-gray-500 hover:text-gray-800">&times;</button>
        </div>

        <div className="flex-grow overflow-y-auto pr-2">
          {loading && <p>Ładowanie...</p>}
          {error && <p className="text-red-600 bg-red-50 p-3 rounded">{error}</p>}
          <div className="space-y-4 mb-6">
            {subfields.map(sf => (
              <div key={sf.subfield_translation_id} className="p-3 border rounded-md bg-gray-50">
                <div className="grid grid-cols-1 md:grid-cols-[1fr_auto_auto] gap-3 items-center">
                  <span className="font-medium text-gray-700">{sf.subfield_name}</span>
                  <input type="number" defaultValue={sf.elo_threshold} onBlur={(e) => handleSaveThreshold(sf.subfield_translation_id, parseInt(e.target.value))} className="w-full md:w-28 text-right border rounded p-1" title="Zapisuje automatycznie po wyjściu z pola" />
                  <button onClick={() => handleDelete(sf.subfield_translation_id, sf.subfield_name)} className="bg-red-500 text-white px-3 py-1 rounded text-sm hover:bg-red-600 transition-colors">Usuń</button>
                </div>
                
                {/* --- NOWA SEKCJA DO WYŚWIETLANIA SZABLONÓW --- */}
                {sf.templates && sf.templates.length > 0 && (
                  <div className="mt-3 pt-3 border-t border-gray-200">
                    <h4 className="text-xs font-semibold text-gray-500 mb-2">Używane szablony w tym poddziale:</h4>
                    <div className="space-y-2">
                      {sf.templates.map(template => (
                        <div key={template.problem_id} className="text-xs p-2 border-l-4 border-blue-300 bg-blue-50 rounded-r">
                          <p className="font-bold text-blue-800">Szablon ID: {template.problem_id}</p>
                          <div className="text-gray-700 italic">
                            <RenderMarkdownWithLatex text={template.question} />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {/* --- KONIEC NOWEJ SEKCJI --- */}
              </div>
            ))}
          </div>
        </div>

        <form onSubmit={handleCreate} className="border-t pt-4 mt-4">
          <h3 className="text-lg font-semibold mb-3 text-gray-700">Dodaj nowy poddział</h3>
          <div className="flex flex-wrap items-center gap-4">
            <input type="text" placeholder="Nazwa poddziału" value={newSubfieldName} onChange={e => setNewSubfieldName(e.target.value)} className="border p-2 rounded flex-grow" required />
            <input type="number" placeholder="Próg ELO" value={newEloThreshold} onChange={e => setNewEloThreshold(parseInt(e.target.value))} className="border p-2 rounded w-full sm:w-32" required />
            <button type="submit" className="bg-green-600 text-white px-5 py-2 rounded font-semibold hover:bg-green-700">Dodaj</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SubfieldManagerModal;